export const POST_TYPE = {
  home: 'home',
  legacy: 'legacy',
  group: 'group',
  school: 'school',
};
